var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-4"},[_vm._v(" Here is how your integrate Telegram Instruction ")])
}
var staticRenderFns = []

export { render, staticRenderFns }